import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "@/features/auth/firebase.js";
import {Navigate, Outlet, useSearchParams} from "react-router-dom";

export function RequireNoAuth() {
  const [user] = useAuthState(auth);
  const [searchParams] = useSearchParams();

  if (user !== null) {
    const to = searchParams.get('redirect') ?? '/';
    return <Navigate to={to} />
  } else {
    return <Outlet />;
  }
}
